import endpoints from "@config/endpoints";
import { errorSuccessMessage } from "@constants/approvalConstants";
import { postDataJSON } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { toast } from "react-toastify";

export const approvalStatusUpdate = async (reducerData: any, comments: any, reqData: any = null, statusChangedId: any, isDataChanged: any = false,requestForName:any , effectiveFromDate : any, status?: string, mobileNumber?: string) => {
    try {
        const payload = {
            requestId: reducerData?.requestTrxnId,
            requestTypeCode: reducerData?.requestTypeCode,
            dataModificationTrackerId: reducerData?.dataModificationTrackerId,
            requestChangedByType: reducerData?.requestFor,
            statusChangedBy: localStorage.getItem('userId'),
            statusId: statusChangedId,
            statusChangedComment: comments,
            isDataChanged: isDataChanged,
            requestData: reqData,
            requestForName: requestForName,
            effectiveFromDt: effectiveFromDate,
            ...(status && { status: status }),
            ...(mobileNumber && { mobileNumber: mobileNumber }),
        };
        const response = await postDataJSON<any>(`${endpoints?.approvalStatusUpdate}`, payload);
        if (response) {
            return response;
        }
    } catch (error: any) {
        toast.error(errorSuccessMessage.statusChangeError, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data || error?.response || error);
    }
};